
import { Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { union_type, string_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { HtmlHelper_createElement } from "../fable_modules/Feliz.3.3.3/Html.fs.js";
import { fontSize_textSm, padding_p2, borderRadius_roundedMd, border_border, display_inlineFlex, tw } from "../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { borderColor_borderInfo500, textColor_textInfo600, backgroundColor_bgInfo50, textColor_textInfo500 } from "./TailwindExtensions.js";
import { useEffect, useReducer, createElement } from "react";
import React from "react";
import { IconWeight, IconSize, IconName, icon } from "./Icons.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.3.0/Seq.js";
import { join } from "../fable_modules/fable-library-js.5.3.0/String.js";
import { disposeSafe } from "../fable_modules/fable-library-js.5.3.0/Util.js";

/**
 * Interactions that decide whether a tooltip revealed by hover or focus is dismissed.
 */
export class Interaction extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Revealed", "KeyPressed"];
    }
}

export function Interaction_$reflection() {
    return union_type("Shared.InfoTooltip.Interaction", [], Interaction, () => [[], [["key", string_type]]]);
}

/**
 * Whether the tooltip is dismissed after an interaction. Escape dismisses it without the pointer
 * or focus having to move (WCAG 2.1 SC 1.4.13 "Dismissible"); the next hover or focus reveals it again.
 */
export function dismissedAfter(dismissed, interaction) {
    if (interaction.tag === 1) {
        if (interaction.fields[0] === "Escape") {
            return true;
        }
        else {
            return dismissed;
        }
    }
    else {
        return false;
    }
}

function render(id, label, text, dismissed, onInteraction) {
    return HtmlHelper_createElement("span", ofArray([["className", tw(ofArray(["group", "relative", display_inlineFlex]))], ["onMouseEnter", (_arg) => {
        onInteraction(new Interaction(0, []));
    }], ["onFocus", (_arg_1) => {
        onInteraction(new Interaction(0, []));
    }], ["children", [HtmlHelper_createElement("button", ofArray([["type", "button"], ["aria-label", label], ["aria-describedby", id], ["className", tw(singleton(textColor_textInfo500))], ["children", [createElement(icon, {
        name: new IconName(35, []),
        size: new IconSize(0, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("span", toList(delay(() => append(singleton_1(["id", id]), delay(() => append(singleton_1(["role", join(" ", ["tooltip"])]), delay(() => append(dismissed ? singleton_1(["hidden", true]) : empty(), delay(() => append(singleton_1(["children", singleton(text)]), delay(() => singleton_1(["className", tw(ofArray(["invisible", "group-hover:visible", "group-focus-within:visible", "absolute", "left-0", "top-full", "z-10", "mt-1", "w-56", backgroundColor_bgInfo50, textColor_textInfo600, border_border, borderColor_borderInfo500, borderRadius_roundedMd, padding_p2, fontSize_textSm]))]))))))))))))]]]));
}

function DismissibleTooltip($props) {
    const text = $props.text;
    const label = $props.label;
    const id = $props.id;
    const patternInput = useReducer(dismissedAfter, false);
    const dispatch = patternInput[1];
    useEffect(() => {
        const setup = (() => {
        let disp;
        const handler = (e) => {
            dispatch(new Interaction(1, [e.key]));
        };
        document.addEventListener("keydown", handler);
        disp = {
            Dispose() {
                document.removeEventListener("keydown", handler);
            },
        };
        return () => {
            let copyOfStruct = disp;
            disposeSafe(copyOfStruct);
        };
    })();
        return setup;
        }, []);;
    return render(id, label, text, patternInput[0], dispatch);
}

/**
 * Info icon button with a tooltip.
 * `id` is the tooltip element id (referenced by aria-describedby), `label` is the button's
 * accessible name, `text` is the tooltip content. The text stays in the DOM so screen readers
 * can read it via aria-describedby; visibility is handled with group-hover / group-focus-within,
 * and on the client Escape dismisses it until the next hover or focus.
 */
export function view(id, label, text) {
    return createElement(DismissibleTooltip, {
        id: id,
        label: label,
        text: text,
    });
}

//# sourceMappingURL=InfoTooltip.js.map
